// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoiceAddendumListContainer {
  text-align: center;
  padding-bottom: 0.5%;
  width: 98%;
}
.invoiceAddendumListContainer li {
  display: block;
}
.invoiceAddendumListContainer .grid.invoice-addendum {
  grid-template-columns: repeat(3, auto);
}
.invoiceAddendumListContainer .grid.invoice-addendum > div:nth-child(18n+4),
.invoiceAddendumListContainer .grid.invoice-addendum > div:nth-child(18n+5),
.invoiceAddendumListContainer .grid.invoice-addendum > div:nth-child(18n+6) {
  background-color: rgba(245, 245, 245, 0.3);
}
.grid {
  padding: 0px !important;
}
mat-card {
  border-radius: 0px !important;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2) !important;
}
.invoice-button {
  width: 30%;
}
`, "",{"version":3,"sources":["webpack://./src/app/invoice/invoice-addendum/invoice-addendum.component.less"],"names":[],"mappings":"AAGA;EACI,kBAAA;EACA,oBAAA;EACA,UAAA;AAFJ;AADA;EAKM,cAAA;AADN;AAJA;EAQM,sCAAA;AADN;AAPA;;;EAaM,0CAAA;AADN;AAIA;EACI,uBAAA;AAFJ;AAKA;EACE,6BAAA;EACA,mDAAA;AAHF;AAOA;EACE,UAAA;AALF","sourcesContent":["@import (reference) url(\"../../../styles.less\");\n\n\n.invoiceAddendumListContainer {\n    text-align:center;\n    padding-bottom: .5%;\n    width: 98%;\n    li {\n      display: block;\n    }\n    .grid.invoice-addendum {\n      grid-template-columns: repeat(3, auto);\n    }\n    .grid.invoice-addendum > div:nth-child(18n+4),\n    .grid.invoice-addendum > div:nth-child(18n+5),\n    .grid.invoice-addendum > div:nth-child(18n+6) {\n      background-color: @grid-row;\n    }\n}\n.grid {\n    padding: 0px !important;\n}\n\nmat-card {\n  border-radius: 0px !important;\n  box-shadow: 0 0 0 1px rgba(0,0,0,.2) !important;\n}\n\n\n.invoice-button{\n  width:30%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
